import {gql} from '@apollo/client'

export const GET_Bookmarked_Video = gql`
mutation VideoBookmark($topicId:String!,$subjectId:String!,$contentId:String!,$isCompleted:Boolean!,$contentType:ContentType!,$duration:DurationInput,$courseName:String!,$isBookMarked:Boolean,$status:ContentPlayStatus,$version:Float){
    upsertContentState(upsertStatusInput:{
          topicId:$topicId
          version:$version
        subjectId:$subjectId,
        contentId:$contentId,
        isCompleted:$isCompleted,
        duration:$duration,
        contentType:$contentType,
        courseName:$courseName,
        isBookMarked:$isBookMarked,
      status:$status
      })
    { 
                      _id
                     courseName
                    contentType
                      topicId
                     isBookMarked
                      video{
                          _id
                          title
                      }
					  pearl{
                        _id
                        title
                    }
                  }
  }`

  export const Bookmark_QB= gql`
  mutation bookmarkQb($resultId: String,$qbId: String!, $questionId: String, $subjectId: String!, $courseName: String!, $status: Boolean!, $resultType: ResultType!) {
    bookmarkQuestionOrQbTest(resultId:$resultId,
        qbId: $qbId,
        resultType: $resultType
        questionId: $questionId,
        subjectId: $subjectId,
        courseName: $courseName,
        status: $status)
}`

export const Result_Submit= gql`
mutation submitQbResult($resultInput: ResultInputDto!) {
  submitResult(resultInput: $resultInput) {
      _id
      rating
      feedback
      isHelpful
      isBookMarked
}
}`

export const Report_Submit=gql`
mutation addUserReport($addReportInput: AddReportInputDto!){
  addUserReport(addReportInput:$addReportInput){
      contentType
      _id
      userId
  }
}`

export const Star_Bookmark=gql`
mutation bookmarkQb($resultId: String,$qbId: String!, $questionId: String,$subjectId: String, $courseName: String!, $status: Boolean!,$resultType: ResultType!,$rating:Float,$feedback:String) {
      bookmarkQuestionOrQbTest(resultId: $resultId,qbId: $qbId,questionId: $questionId,subjectId: $subjectId,courseName: $courseName,status: $status, resultType:$resultType,rating: $rating, feedback:$feedback)
  }`

export const Question_Bookmark=gql`
mutation bookmark($status:Boolean!,$resultType: ResultType!,$qbId: String!, $questionId: String!,$subjectId: String, $courseName: String!, $userAnswer: String,$topicId:String) {
  bookmarkQuestion(status:$status,resultType: $resultType,qbId: $qbId,questionId: $questionId,subjectId: $subjectId,courseName: $courseName,userAnswer: $userAnswer,topicId:$topicId){
    _id
questionId
userAnswer
qbId
resultType
courseName
userId
subjectId
topicId
question{
_id
}
testQuestion{
  _id
}
  }
}`

export const BookmarkQuestionAttempt=gql`
 mutation  upsertUserAnswerBookmark($upsertAnswerBookmarkInput:[UpsertUserAnswerInputDto!]!){
	upsertUserAnswerBookmark(upsertAnswerBookmarkInput: $upsertAnswerBookmarkInput) {
		modifiedCount
		 matchedCount
   }
 }
`

  

